import React from "react";
import { CLIENT_ADMIN } from "src/utils/pnd/PndConstants";

function TopBarClientInformation() {
    return (

        <div className="topbar__justify" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: '20px', height: '100%' }}>
            <h3 className="profile_name" style={{ margin: 0, fontSize: '20px', lineHeight: '24px' }}>{localStorage.getItem('clientName')}</h3>
            {localStorage.getItem('uri') == CLIENT_ADMIN &&
                localStorage.getItem('subscriptionEndDateInDays') &&
                parseInt(localStorage.getItem('subscriptionEndDateInDays'), 10) > 30 ? (
                <h6 style={{ margin: 0, fontFamily: 'ProductSansLight', fontSize: 13, color: '#21b368' }}>
                    Subscription Ends in {localStorage.getItem('subscriptionEndDateInDays')} Days
                </h6>
            ) : parseInt(localStorage.getItem('subscriptionEndDateInDays'), 10) < 30 ? (
                <h6 style={{ margin: 0, fontFamily: 'ProductSansLight', fontSize: 13, color: 'red' }}>
                    Subscription Ends in {localStorage.getItem('subscriptionEndDateInDays')} Days
                </h6>
            ) : null
            }

        </div>
    );
}

export default TopBarClientInformation;
